import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../hooks/apiClient";
import { useStore } from "../../authContext/StoreContext";
import { useSnackbar } from "notistack";
import { Button, Box, Grid } from "@mui/material";
import LaamBarcodesDialog from "./components/LaamBarcodeDialog";
const ProductDetails = ({ authToken }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const { selectedStore, isStoreSelected } = useStore();
  const store = isStoreSelected && selectedStore.id;
  const [productData, setProductData] = useState();
  const [newInventoryValues, setNewInventoryValues] = useState({});
  const [newSkus, setNewSkus] = useState({});
  const [newBarcodes, setNewBarcodes] = useState({});
  const [fullPData, setFullPData] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [productExist, setProductExist] = useState(false);
  const [isLaamSynced, setIsLaamSynced] = useState(false);
  const [laamTitle, setLaamTitle] = useState("");
  const [selectedSkus, setSelectedSkus] = useState([]);
  const [selectedBarcodes, setSelectedBarcodes] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [proCountData, setProCount] = useState(0);
  const tableRef = useRef(null);

  const handleInventoryChange = (inv_id, newValue) => {
    setNewInventoryValues((prev) => ({
      ...prev,
      [inv_id]: newValue,
    }));
  };
  const handleSkus = (inv_id, newValue) => {
    setNewSkus((prev) => ({
      ...prev,
      [inv_id]: newValue,
    }));
  };
  const handleBarcodes = (inv_id, newValue) => {
    setNewBarcodes((prev) => ({
      ...prev,
      [inv_id]: newValue,
    }));
  };
  const fetchData = async () => {
    try {
      const response = await api.get(`products/find/${id}`);

      setFullPData(response.data);
      setLaamTitle(response.data.laam_title);
      const fullData = processProductData(response.data);

      setProductData(fullData);
      setIsLaamSynced(fullData.laam_sync);

      await fetchOrderData(fullData.laam_sync);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const processProductData = (data) => {
    if (!data) return null;

    const processed = { ...data };
    if (processed.laam_sync && Array.isArray(processed.variants)) {
      processed.variants = processed.variants.filter(
        (variant) => variant.shopifyInventory > 0
      );
    }
    processed.totalQuantity = processed.variants?.reduce(
      (sum, variant) => sum + (variant.inventory_quantity || 0),
      0
    );

    return processed;
  };

  const fetchOrderData = async (isLaamed) => {
    if (!isLaamed) return;

    try {
      const response = await api.get(`orders/laam/bystore/${store}`, {
        params: {
          order_type: 2,
          product_id: id,
        },
      });

      const fullDataOrder = response.data.orders[0];

      setOrderData(fullDataOrder);
      setProCount(response.data.count);
      if (
        fullDataOrder?.laam_order_details &&
        Array.isArray(fullDataOrder.laam_order_details)
      ) {
        const productExist = fullDataOrder.laam_order_details.find(
          (item) => item.product_id == id
        );
        setProductExist(!!productExist);
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);

  // auto fill

  const handleSkuSelect = (variantId) => {
    setSelectedSkus((prev) =>
      prev.includes(variantId)
        ? prev.filter((id) => id !== variantId)
        : [...prev, variantId]
    );
  };

  const handleBarcodeSelect = (variantId) => {
    setSelectedBarcodes((prev) =>
      prev.includes(variantId)
        ? prev.filter((id) => id !== variantId)
        : [...prev, variantId]
    );
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const rows = pastedData.split("\n").filter((row) => row.trim() !== "");

    // Determine which field we're pasting into
    const isPastingSkus = selectedSkus.length > 0;
    const targetVariants = isPastingSkus ? selectedSkus : selectedBarcodes;

    if (targetVariants.length !== rows.length) {
      enqueueSnackbar(
        `Selected ${targetVariants.length} variants but pasted ${rows.length} values`,
        { variant: "warning" }
      );
      return;
    }

    if (isPastingSkus) {
      const updatedSkus = { ...newSkus };
      targetVariants.forEach((variantId, index) => {
        updatedSkus[variantId] = rows[index].split("\t")[0].trim();
      });
      setNewSkus(updatedSkus);
      setSelectedSkus([]);
    } else {
      const updatedBarcodes = { ...newBarcodes };
      targetVariants.forEach((variantId, index) => {
        updatedBarcodes[variantId] = rows[index].split("\t")[0].trim();
      });
      setNewBarcodes(updatedBarcodes);
      setSelectedBarcodes([]);
    }

    enqueueSnackbar(
      `Updated ${rows.length} ${isPastingSkus ? "SKUs" : "barcodes"}`,
      { variant: "success" }
    );
  };

  useEffect(() => {
    const table = tableRef.current;
    if (table) {
      table.addEventListener("paste", handlePaste);
      return () => table.removeEventListener("paste", handlePaste);
    }
  }, [selectedSkus, selectedBarcodes, newSkus, newBarcodes]);
  // auto fill

  useEffect(() => {
    if (productData?.variants?.length > 0) {
      const initialSkus = {};
      const initialBarcodes = {};

      productData.variants.forEach((variant) => {
        initialSkus[variant.id] = newSkus[variant.id] || ""; // preserve if already typed
        initialBarcodes[variant.id] = newBarcodes[variant.id] || "";
      });

      setNewSkus(initialSkus);
      setNewBarcodes(initialBarcodes);
    }
  }, [productData]);

  const findVaraintExist = (variant_id) => {
    const found = orderData.laam_order_details.find(
      (dt) => dt.variant_id == variant_id
    );
    return `In This Order ${found.quantity}`;
  };
  const sendToLaam = async () => {
    setBtnLoading(true);
    try {
      const newVariants = productData.variants.map((variant) => ({
        ...variant,
        new_quantity: newInventoryValues[variant.id] ?? 0,
        product_title: productData.laam_title,
      }));

      const response = await api.post(
        `orders/laam/bystore/${productData.store_id}`,
        {
          variants: newVariants,
        }
      );

      setNewInventoryValues({});
      await fetchData();

      enqueueSnackbar("Added in the order go next...", {
        variant: "success",
      });
      setBtnLoading(false);
    } catch (error) {
      console.error("Error fetching product data:", error);
      setBtnLoading(false);
      enqueueSnackbar("not added in the order empty...", {
        variant: "error",
      });
    }
  };
  const returnFromLaam = async () => {
    setBtnLoading(true);
    try {
      const newVariants = productData.variants.map((variant) => ({
        ...variant,
        new_quantity: newInventoryValues[variant.id] ?? 0,
        product_title: productData.laam_title,
      }));

      const response = await api.post(
        `orders/return/laam/bystore/${productData.store_id}`,
        {
          variants: newVariants,
        }
      );

      setNewInventoryValues({});
      await fetchData();

      enqueueSnackbar("Added in the order go next...", {
        variant: "success",
      });
      setBtnLoading(false);
    } catch (error) {
      console.error("Error fetching product data:", error);
      setBtnLoading(false);
      enqueueSnackbar("not added in the order empty...", {
        variant: "error",
      });
    }
  };
  const saveLaamStatus = async () => {
    setLoading(true);
    const hasEmptyFields =
      Object.values(newSkus).some((val) => val.trim() === "") ||
      Object.values(newBarcodes).some((val) => val.trim() === "");

    if (hasEmptyFields) {
      enqueueSnackbar("Please fill all SKU and Barcode fields", {
        variant: "warning",
      });
      setLoading(false);
      return;
    }
    if (!laamTitle) {
      enqueueSnackbar("Please fill laam Title Value ....", {
        variant: "warning",
      });
      setLoading(false);
      return;
    }

    const mapped = Object.entries(newBarcodes).map(([key, value]) => ({
      id: key,
      laam_barcode: value,
    }));

    const mapped2 = Object.entries(newSkus).map(([key, value]) => ({
      id: key,
      laam_sku: value,
    }));
    const mergedSkuBar = mapped.map((barcodeItem) => {
      const skuItem = mapped2.find((item) => item.id === barcodeItem.id);
      return {
        ...barcodeItem,
        laam_sku: skuItem ? skuItem.laam_sku : null,
      };
    });

    try {
      await api.put("products/laam/status", {
        laam_data: mergedSkuBar,
        laam_title: laamTitle,
        product_id: productData.id,
      });

      await fetchData();
      enqueueSnackbar("Added successfully to Laam!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Error occurred while syncing to Laam!", {
        variant: "error",
      });
      console.error("Laam sync error:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleRowClick = (o_id) => {
    navigate(`/laam/orders/${o_id}`, { replace: false });
  };
  const handleEditClick = () => {
    if (fullPData?.variants?.length > 0) {
      setProductData(fullPData);
      const skus = {};
      const barcodes = {};

      fullPData.variants.forEach((variant) => {
        skus[variant.id] = variant.laam_sku || "";
        barcodes[variant.id] = variant.laam_barcode || "";
      });

      setNewSkus(skus);
      setNewBarcodes(barcodes);
      setIsLaamSynced(false); // Show editable fields
    }
  };

  if (loading || !productData) {
    return (
      <div className="container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="container py-4">
      <LaamBarcodesDialog
        ToggleOpen={() => setOpenDialog(false)}
        open={openDialog}
        product={productData}
      />
      <div className="card shadow">
        <div className="card-header bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="mb-0">{productData.title}</h4>
            {proCountData > 0 && (
              <span className="badge bg-warning">
                Sent To Laam ({proCountData})
              </span>
            )}
            <Button onClick={() => handleEditClick()}>
              {" Edit"}
              <EditIcon />
            </Button>

            <span
              className={`badge bg-${isLaamSynced ? "success" : "warning"}`}
            >
              {productData.status} {isLaamSynced ? "(Laam Sync)" : ""}
            </span>
          </div>

          {orderData && isLaamSynced && (
            <div
              className="mt-2 p-2 bg-light rounded cursor-pointer"
              onClick={() => handleRowClick(orderData.id)}
            >
              {productExist && (
                <span className="text-warning me-2">
                  <i className="bi bi-exclamation-triangle-fill me-1"></i>
                  Product exists in this order
                </span>
              )}
              <span>Order #{orderData.id}</span>
            </div>
          )}
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-md-5 mb-4 mb-md-0">
              <img
                src={productData.image_src}
                alt={productData.title}
                className="img-fluid rounded"
                style={{ maxHeight: "400px", objectFit: "contain" }}
              />
            </div>

            <div className="col-md-7">
              {isLaamSynced ? (
                <span>
                  <span className="badge bg-warning mb-1">Laam Title: </span>{" "}
                  <span>{laamTitle}</span>
                </span>
              ) : (
                <input
                  type="text"
                  className="form-control form-control-sm mb-1"
                  value={laamTitle}
                  onChange={(e) => setLaamTitle(e.target.value)}
                />
              )}

              <div className="table-responsive" ref={tableRef}>
                <table className="table table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>Variant</th>
                      <th>Current Qty</th>
                      <th>VLV SKU</th>
                      {isLaamSynced && <th>Laam Barcode</th>}
                      <th>{isLaamSynced ? "Laam Qty" : "Laam SKU"}</th>
                      {!isLaamSynced && <th>Laam Barcode</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {productData.variants.map((variant) => (
                      <tr key={variant.id}>
                        <td>
                          <Link
                            to={`/variant/${variant.sku}`}
                            className="text-decoration-none"
                          >
                            {variant.title}{" "}
                            <i className="bi bi-chevron-right"></i>
                          </Link>
                        </td>
                        <td>
                          <div>
                            <span className="fw-bold">
                              {variant.shopifyInventory}
                            </span>
                            <div className="text-muted fontS fw-bold">
                              <span
                                className={
                                  variant.inventory_quantity !=
                                    variant.shopifyInventory &&
                                  "bg-danger rounded p-1 text-white"
                                }
                              >
                                DB ({variant.inventory_quantity})
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span className="fw-bold fontS">
                              {variant.barcode}
                            </span>
                            <div className="text-muted fontS">
                              {variant.sku}
                            </div>
                          </div>
                        </td>
                        {isLaamSynced && (
                          <td>
                            <div>
                              <span className="fw-bold fontS">
                                {variant.laam_barcode}
                              </span>
                              <div className="text-muted fontS">
                                {variant.laam_sku}
                              </div>
                            </div>
                          </td>
                        )}
                        {isLaamSynced ? (
                          <td>
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={newInventoryValues[variant.id] || ""}
                              onChange={(e) =>
                                handleInventoryChange(
                                  variant.id,
                                  parseInt(e.target.value) || 0
                                )
                              }
                            />
                            {productExist && (
                              <div className="text-muted small">
                                In order:{" "}
                                {orderData.laam_order_details.find(
                                  (dt) => dt.variant_id == variant.id
                                )?.quantity || 0}
                              </div>
                            )}
                          </td>
                        ) : (
                          <>
                            <td>
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={newSkus[variant.id] || ""}
                                  onChange={(e) =>
                                    handleSkus(variant.id, e.target.value)
                                  }
                                />
                                <input
                                  type="checkbox"
                                  checked={selectedSkus.includes(variant.id)}
                                  onChange={() => handleSkuSelect(variant.id)}
                                  className="position-absolute"
                                  style={{
                                    right: "5px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    zIndex: 1,
                                  }}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={newBarcodes[variant.id] || ""}
                                  onChange={(e) =>
                                    handleBarcodes(variant.id, e.target.value)
                                  }
                                />
                                <input
                                  type="checkbox"
                                  checked={selectedBarcodes.includes(
                                    variant.id
                                  )}
                                  onChange={() =>
                                    handleBarcodeSelect(variant.id)
                                  }
                                  className="position-absolute"
                                  style={{
                                    right: "5px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    zIndex: 1,
                                  }}
                                />
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="d-grid mt-3">
                {isLaamSynced ? (
                  <button
                    className="btn btn-primary"
                    onClick={sendToLaam}
                    disabled={btnLoading}
                  >
                    {btnLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Send to Laam"
                    )}
                  </button>
                ) : (
                  <button
                    className="btn btn-success"
                    onClick={saveLaamStatus}
                    disabled={btnLoading}
                  >
                    {btnLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <>
                        <SaveIcon className="me-2" fontSize="small" />
                        Save Laam Data
                      </>
                    )}
                  </button>
                )}
                {isLaamSynced && (
                  <Box my={1} display="flex" alignItems="center" gap={1}>
                    <Button
                      color="primary"
                      onClick={returnFromLaam}
                      loadingPosition="start"
                      startIcon={<FingerprintIcon />}
                      variant="outlined"
                    >
                      Add Return Order
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => setOpenDialog(true)}
                      loadingPosition="start"
                      startIcon={<PrintIcon />}
                      variant="outlined"
                    >
                      Print Barcodes
                    </Button>
                  </Box>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
